// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlock {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, children) {
        var _a, _b;
        this.id = model.persistentId;
        this.children = children;
        this.type = model.type;
        this.beginsTypeChain = true; // Will be computed by resolver
        this.endsTypeChain = true; // Will be computed by resolver
        this.theme = model.theme ? model.theme : null;
        this.variantKey = (_a = model.variantKey) !== null && _a !== void 0 ? _a : null;
        this.blacklistedElementProperties =
            (_b = model.blacklistedElementProperties) !== null && _b !== void 0 ? _b : null;
        if (model.userMetadata) {
            // TODO:fix-sdk-eslint
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            this.userMetadata = JSON.parse(model.userMetadata);
        }
        else {
            this.userMetadata = null;
        }
    }
}
